import {Stack, Typography} from "@mui/material";
import ThemeToggle from "layouts/app/ThemeToggle";
import type {FC} from "react";

type ToolbarActionsProps = {
  loading: boolean;
  units: string;
  isMobile: boolean;
};

const ToolbarActions: FC<ToolbarActionsProps> = props => {
  const {loading, units, isMobile} = props;

  return (
    <Stack direction="row" alignItems="center" spacing={2}>
      {!isMobile && (
        <Typography variant="body2" noWrap>
          Units: {loading ? "loading units" : units}
        </Typography>
      )}
      <ThemeToggle />
    </Stack>
  );
};

export default ToolbarActions;
